module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-margin flexed-column-wrapper-fixed-side",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "rest-of-height side-nav-slot overflow-y",
    style: ({
      maxWidth: _vm.size_of_side_nav,
      backgroundColor: _vm.nav_background_color,
    })
  }, [_vm._t("side-nav-slot")], 2), _vm._v(" "), _c('div', {
    staticClass: "fixed-sidebar-body col-xs rest-of-height no-padding",
    staticStyle: {
      "position": "relative",
      "overflow-x": "hidden"
    },
    attrs: {
      "id": _vm.bodyID
    }
  }, [_vm._t("side-body-slot")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-57a2825d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/fixedSideBar/fixedSideBar.vue
// module id = 1662
// module chunks = 61